(() => {
  const SELECTORS = {
  root: '[data-video-blog-grid]',
  card: '[data-video-card]',
  filter: '[data-video-filter]',
  filterTrack: '[data-video-filter-track]',
  filterPrev: '[data-video-filter-prev]',
  filterNext: '[data-video-filter-next]',
  tagShortcut: '[data-video-filter-shortcut]',
  loadMore: '[data-video-load-more]',
  empty: '[data-video-empty]',
  trigger: '[data-video-card-trigger]'
};

  const parseNumber = (value, fallback) => {
    const parsed = Number.parseInt(value, 10);
    return Number.isFinite(parsed) ? parsed : fallback;
  };

  const extractYouTubeId = (input) => {
    if (!input) return '';

    let value = String(input).trim();

    // Already a clean YouTube ID
    if (/^[a-zA-Z0-9_-]{11}$/.test(value)) {
      return value;
    }

    try {
      const url = new URL(value);

      // youtube.com/watch?v=VIDEO_ID
      const vParam = url.searchParams.get('v');
      if (vParam && /^[a-zA-Z0-9_-]{11}$/.test(vParam)) {
        return vParam;
      }

      // youtu.be/VIDEO_ID
      if (url.hostname.includes('youtu.be')) {
        const id = url.pathname.split('/').filter(Boolean)[0];
        if (id && /^[a-zA-Z0-9_-]{11}$/.test(id)) {
          return id;
        }
      }

      // youtube.com/embed/VIDEO_ID
      // youtube.com/shorts/VIDEO_ID
      // youtube.com/live/VIDEO_ID
      const parts = url.pathname.split('/').filter(Boolean);
      const knownPathIndex = parts.findIndex((part) => ['embed', 'shorts', 'live'].includes(part));

      if (knownPathIndex !== -1 && parts[knownPathIndex + 1]) {
        const id = parts[knownPathIndex + 1];
        if (/^[a-zA-Z0-9_-]{11}$/.test(id)) {
          return id;
        }
      }
    } catch (error) {
      // Not a valid URL, continue with string fallback below.
    }

    // Last-resort regex fallback
    const match = value.match(/(?:v=|youtu\.be\/|embed\/|shorts\/|live\/)([a-zA-Z0-9_-]{11})/);
    return match ? match[1] : '';
  };

  const buildIframe = (button) => {
    const rawVideoId = button.dataset.youtubeId || '';
    const rawVideoSource = button.dataset.youtubeSource || '';
    const videoId = extractYouTubeId(rawVideoId) || extractYouTubeId(rawVideoSource);
    const videoTitle = button.dataset.videoTitle || 'Video';

    if (!videoId) {
      console.warn('Video Recipe Grid: Missing or invalid YouTube ID.', {
        rawVideoId,
        rawVideoSource
      });
      return;
    }

    const media = button.closest('.video-recipe-card__media');
    if (!media) return;

    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0&modestbranding=1&playsinline=1`;
    iframe.title = videoTitle;
    iframe.loading = 'lazy';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;

    media.innerHTML = '';
    media.appendChild(iframe);
    media.classList.add('video-recipe-card__media--loaded');
  };

  const setupThumbnailFallbacks = (root) => {
    const images = root.querySelectorAll('img[data-fallback-thumbnail]');

    images.forEach((image) => {
      image.addEventListener(
        'error',
        () => {
          const fallback = image.dataset.fallbackThumbnail;
          if (fallback && image.src !== fallback) {
            image.src = fallback;
          }
        },
        { once: true }
      );
    });
  };

  const initVideoBlogGrid = (root) => {
    if (!root || root.dataset.videoBlogGridInitialized === 'true') return;

    root.dataset.videoBlogGridInitialized = 'true';

    const cards = Array.from(root.querySelectorAll(SELECTORS.card));
    const filters = Array.from(root.querySelectorAll(SELECTORS.filter));
    const filterTrack = root.querySelector(SELECTORS.filterTrack);
    const filterPrev = root.querySelector(SELECTORS.filterPrev);
    const filterNext = root.querySelector(SELECTORS.filterNext);
    const tagShortcuts = Array.from(root.querySelectorAll(SELECTORS.tagShortcut));
    const loadMoreButton = root.querySelector(SELECTORS.loadMore);
    const loadMoreWrap = loadMoreButton ? loadMoreButton.closest('.video-recipe-blog-grid__load-more-wrap') : null;
    const emptyMessage = root.querySelector(SELECTORS.empty);

    const initialCount = parseNumber(root.dataset.initialCount, 12);
    const loadCount = parseNumber(root.dataset.loadCount, 6);

    let activeFilter = 'all';
    let visibleCount = initialCount;

    const getMatchingCards = () => {
      if (activeFilter === 'all') return cards;

      return cards.filter((card) => {
        const tags = (card.dataset.videoTags || '').split(' ').filter(Boolean);
        return tags.includes(activeFilter);
      });
    };

    const setActiveFilterButton = () => {
      filters.forEach((filter) => {
        const isActive = filter.dataset.videoFilter === activeFilter;
        filter.classList.toggle('is-active', isActive);
        filter.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      });
    };

    const setupFilterScroller = () => {
  if (!filterTrack || !filterPrev || !filterNext) return;

  const getScrollAmount = () => {
    return Math.max(filterTrack.clientWidth * 0.75, 240);
  };

  const updateFilterButtons = () => {
    const maxScroll = filterTrack.scrollWidth - filterTrack.clientWidth - 2;
    const hasOverflow = maxScroll > 2;

    filterPrev.hidden = !hasOverflow;
    filterNext.hidden = !hasOverflow;

    if (!hasOverflow) return;

    filterPrev.disabled = filterTrack.scrollLeft <= 2;
    filterNext.disabled = filterTrack.scrollLeft >= maxScroll;
  };

  filterPrev.addEventListener('click', () => {
    filterTrack.scrollBy({
      left: -getScrollAmount(),
      behavior: 'smooth'
    });
  });

  filterNext.addEventListener('click', () => {
    filterTrack.scrollBy({
      left: getScrollAmount(),
      behavior: 'smooth'
    });
  });

  filterTrack.addEventListener('scroll', updateFilterButtons, { passive: true });
  window.addEventListener('resize', updateFilterButtons);

  updateFilterButtons();
};

    const renderCards = () => {
      const matchingCards = getMatchingCards();

      cards.forEach((card) => {
        card.hidden = true;
        card.classList.remove('is-visible');
      });

      matchingCards.slice(0, visibleCount).forEach((card, index) => {
        card.hidden = false;

        window.requestAnimationFrame(() => {
          setTimeout(() => {
            card.classList.add('is-visible');
          }, index * 35);
        });
      });

      if (emptyMessage) {
        emptyMessage.hidden = matchingCards.length > 0;
      }

      const hasMore = matchingCards.length > visibleCount;

      if (loadMoreWrap) {
        loadMoreWrap.hidden = !hasMore;
      }

      if (loadMoreButton) {
        loadMoreButton.disabled = !hasMore;
      }
    };

    const applyFilter = (filterValue) => {
  activeFilter = filterValue || 'all';
  visibleCount = initialCount;
  setActiveFilterButton();

  if (filterTrack) {
    const activeButton = filterTrack.querySelector(`[data-video-filter="${activeFilter}"]`);

    if (activeButton) {
      activeButton.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });
    }
  }

  renderCards();
};

    filters.forEach((filter) => {
      filter.addEventListener('click', () => {
        applyFilter(filter.dataset.videoFilter);
      });
    });

    tagShortcuts.forEach((shortcut) => {
      shortcut.addEventListener('click', () => {
        applyFilter(shortcut.dataset.videoFilterShortcut);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });

    if (loadMoreButton) {
      loadMoreButton.addEventListener('click', () => {
        visibleCount += loadCount;
        renderCards();
      });
    }

    setupThumbnailFallbacks(root);
    setupFilterScroller();
    setActiveFilterButton();
    renderCards();
  };

  const initAll = () => {
    document.querySelectorAll(SELECTORS.root).forEach(initVideoBlogGrid);
  };

  // Global delegated click handler.
  // This is intentionally outside initVideoBlogGrid so video clicks still work
  // even if the section is loaded, reloaded, filtered, or edited dynamically.
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest(SELECTORS.trigger);
    if (!trigger) return;

    event.preventDefault();
    event.stopPropagation();

    buildIframe(trigger);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target.querySelector(SELECTORS.root);
    if (root) initVideoBlogGrid(root);
  });
})();